<template>
	<div>
		<div class="system_container">
			<p style="margin: 4rem 0;" class="sub_menu_title">系统架构</p>
			<div class="system_box_t">
				<div class="system_box_t_list">
					<div class="sys_box">
						<div>

							<p class="system_box_t_title">PC端</p>
							<p class="system_box_t_msg">PC端在网页进行功能预约，了解培训信息，下载资料使用更多功能</p>
						</div>
						<img class="system_box_t_img" src="../../../assets/static/images/shebei.png">
					</div>
				</div>
				<div class="system_box_t_list">
					<div class="sys_box">
						<div>
							<p class="system_box_t_title">手机端</p>
							<p class="system_box_t_msg">手机端随时随地接收消息推送，时刻关注信息变动，便携预约功能查看数据。</p>
						</div>
						<img class="system_box_t_img" src="../../../assets/static/images/iphone.png">
					</div>
				</div>
			</div>
			<div class="system_box_b">
				<div class="system_box_b_list">
					<div class="sys_box_list">
					<p class="system_box_b_title">后台管理</p>
					<p  class="system_box_b_msg">后台进行权限分配，电子化管理人员、培训、仪器耗材等管理</p>
					</div>
					<img class="system_box_b_img"  src="../../../assets/static/images/houtai.png" />
				</div>
				<div class="system_box_b_list">
					<div class="sys_box_list">
					<p class="system_box_b_title">数据资源</p>
					<p  class="system_box_b_msg">后台对相关数据进行记录与统计，清晰展示人员、费用等实验数据</p>
					</div>
					<img class="system_box_b_img"  src="../../../assets/static/images/ziyuan.png" />
				</div>
				<div class="system_box_b_list">
					<div class="sys_box_list">
					<p class="system_box_b_title">物联网智能硬件</p>
					<p  class="system_box_b_msg">仪器智能控制器或人脸识别等硬件与后台信息互联，保存每日相关信息与数据</p>
					</div>
					<img class="system_box_b_img"  src="../../../assets/static/images/wulian.png" />
				</div>
			</div>
		</div>
		<div class="ratio">
			<img class="ratio_img" src="../../../assets/static/images/zhanbitu.png">
		</div>
		<div class="service_container_lage">
			<p style="padding: 5rem 0 3.5rem 0;" class="sub_menu_title">业务模块功能</p>
			<div class="service_container">
				
				<div class="service_table">
					<div class="service_box_lage">
						<div>
							<div style="padding:4rem 3rem;">
								<p class="service_box_lage_title">系统管理类型</p>
								<p class="service_box_lage_msg">系统拥有多个管理类型，根据客户需求定制相应的功能</p>
							</div>
							<img class="service_box_lage_img" src="../../../assets/static/images/book.png">
						</div>
					</div>
					<div class="service_box_list">
						<div class="service_box_middle">
							<p class="service_box_middle_title">人员管理</p>
							<p class="service_box_middle_msg">人员根据客户需求分为内、外部人员，管理分配权限，状态实时更新以及查询绩效考核.</p>
						</div>
						<div class="service_box_middle">
							<p class="service_box_middle_title">仪器管理</p>
							<p class="service_box_middle_msg">管理仪器基本信息，预约记录与审核以及相关仪器维修记录、刷卡信息记录</p>
						</div>
						<div class="service_box_middle  bor_right_hide">
							<p class="service_box_middle_title">培训管理</p>
							<p class="service_box_middle_msg">单位相关培训记录、线上考试、根据自身单位要求定制考试内容审核资质。</p>
						</div>
						<div class="service_box_middle">
							<p class="service_box_middle_title">权限管理</p>
							<p class="service_box_middle_msg">授权分配人员管理权限，分级授权共同分层管理后台信息</p>
						</div>
						<div class="service_box_middle">
							<p class="service_box_middle_title">效率统计</p>
							<p class="service_box_middle_msg">检索导出使用时间收费总额，人员数量、个人消费等各种</p>
						</div>
						<div class="service_box_middle bor_right_hide">
							<p class="service_box_middle_title">预约管理</p>
							<p class="service_box_middle_msg">网站预约信息反馈，根据单位要求制定规则，设定规则内容</p>
						</div>
						<div class="service_box_middle bor_bottom_hide">
							<p class="service_box_middle_title">耗材管理</p>
							<p class="service_box_middle_msg">进出库数据信息记录管理，耗材数量、价格消失设定，账户具体扣款信息</p>
						</div>
						<div class="service_box_middle bor_bottom_hide">
							<p class="service_box_middle_title ">收费管理</p>
							<p class="service_box_middle_msg">收费规则设定，使用分时分段收费，使用记时收费周期收费</p>
						</div>
						<div class="service_box_middle bor_bottom_hide bor_right_hide">
							<p class="service_box_middle_title">实验数据</p>
							<p class="service_box_middle_msg">数据网盘网盘储存，避免U盘病毒威胁，数据网上下载，数据更改记录，数据可溯源</p>
						</div>
					</div>
					
					
				</div>
			</div>
		</div>
		
	</div>
</template>

<script>
	import { scrollAnimation } from '../../../utils/js/scrollAnimation.js';
	export default {
		created(){
			const currentY = document.documentElement.scrollTop || document.body.scrollTop
			scrollAnimation(currentY, 800)
		},
	}
</script>

<style lang="less" scoped>
	.system_container{
		
		.system_box_t{
			display: flex;
			width: 75rem;
			margin: 0 auto;
		}
		.system_box_t_list{
			width: 36.75rem;
			height: 13.625rem;
			background: #FFFFFF;
			box-shadow: 0 0.3125rem 0.625rem 0 rgba(176,176,176,0.5);
			margin: 0 1rem;
			padding: 2rem 0;
			padding-left: 3rem;
			padding-right: 2rem;
			
		}
		.system_box_t_title{
			font-size: 1.25rem;
			font-family: PingFang-SC-Bold, PingFang-SC;
			font-weight: bold;
			color: #333333;
		}
		.system_box_t_msg{
			font-size: 0.875rem;
			width: 18.75rem;
			font-family: PingFangSC-Regular, PingFang SC;
			font-weight: 400;
			color: #333333;
		}
		.sys_box{
			display: flex;
			// justify-content: center;
			// align-items: center;
			flex-direction: column;
		}
		.system_box_t_img{
			align-self: flex-end;
			margin-top: -4rem;
		}
		.system_box_b{
			display: flex;
			width: 75rem;
			margin: 0 auto;
			margin-top: 1rem;
			justify-content: space-between;
		}
		.system_box_b_list{
			position: relative;
			margin: 0 1rem;
			text-align: center;
			}
			.sys_box_list{
				position: absolute;top: 3rem;z-index: 50;
				padding: 0 1.5rem;
			}
			.system_box_b_msg{
				text-align: left;
				font-size: 0.9375rem;
				font-family: PingFangSC-Regular, PingFang SC;
				font-weight: 400;
				color: #333333;
				line-height: 1.3125rem;
			}
			.system_box_b_title{
				font-size: 1.25rem;
				font-family: PingFang-SC-Bold, PingFang-SC;
				font-weight: bold;
				color: #333333;
				margin-top: -1rem;
				padding-bottom: 0.5rem;
			}
			.system_box_b_img{
				transform: scale(1);
				height: 26.5rem;
				width: 24rem;
				margin-left: -0.7rem;
				
			}
	}
	.ratio{
		width: 75rem;
		margin: 6rem auto;
		.ratio_img{
			
		}
	}
	.service_container_lage{
		width: 100%;
		height: 70.875rem;
		background: #F9FAFC;
		.service_container{
			width:75rem;
			background: #F9FAFC;
			margin: 0 auto;
			background: #FFFFFF;
			box-shadow: 0 0.3125rem 0.5625rem 0 rgba(191,191,191,0.5);
			border-radius: 0.5625rem;
			position: relative;
			.service_box_lage{
				width: 75rem;
				height: 13.375rem;
				background: linear-gradient(180deg, #EEF1FF 0%, #F7F8FE 100%);
				border-radius: 0.5625rem;
			}
			.service_box_lage_img{
				position: absolute;
				transform: scale(0.9);
				right: 4rem;
				top: 1rem;
			}
			.service_table{
				
			}
			.service_box_middle{
				width: 33%;
				height: 11.875rem;
				background-color: #FFFFFF;
				border-right: 0.0625rem solid #D4D5DB;
				border-bottom: 0.0625rem solid #D4D5DB;
				display: flex;
				flex-direction: column;
				justify-content: center;
				padding: 0 2rem;
			}
			.service_box_list{
				display: flex;
				flex-wrap: wrap;
				justify-content:center ;
			}
			.bor_right_hide{
				border-right: none;
			}
			.bor_bottom_hide{
				border-bottom: none;
			}
			.service_box_lage_title{
				font-size: 1.5rem;
				font-family: PingFangSC-Regular, PingFang SC;
				font-weight: 400;
				color: #333333;
				line-height: 2.125rem;
			}
			.service_box_lage_msg{
				font-size: 1.25rem;
				font-family: PingFangSC-Regular, PingFang SC;
				font-weight: 400;
				color: #666666;
				line-height: 1.75rem;
			}
			.service_box_middle_title{
				font-size: 1.375rem;
				font-family: PingFangSC-Regular, PingFang SC;
				font-weight: 400;
				color: #333333;
				line-height: 1.875rem;
			}
			.service_box_middle_msg{
				font-size: 1rem;
				font-family: PingFangSC-Regular, PingFang SC;
				font-weight: 400;
				color: #666666;
				line-height: 1.375rem;
			}
		}
	}
	
</style>
